// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2JdwP","alertIcon":"ConfirmModal_alertIcon__1pj-Y"};